import { useState } from 'react';
import classNames from 'utilities/ClassNames';
import { StatWidget } from 'components/shared/StatWidget';

interface TimeFilterProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const TimeFilter = ({ label, isActive, onClick }: TimeFilterProps) => (
  <button
    onClick={onClick}
    className={classNames(
      'px-6 py-2 relative z-10 transition-colors duration-200 text-sm',
      isActive ? 'text-white' : 'text-gray-400 hover:text-gray-300'
    )}
  >
    {label}
  </button>
);

export default function OrganizationHeader({ type = "superadmin" }: { type?: string }) {
  const [selectedTime, setSelectedTime] = useState('all');
  
  const timeFilters = [
    { id: 'all', label: 'All Time' },
    { id: '12m', label: '12 Months' },
    { id: '30d', label: '30 Days' },
    { id: '7d', label: '7 Days' },
    { id: '24h', label: '24 Hour' },
  ];

  const [stats, setStats] = useState([
    { id: 1, label: type === "superadmin" ? "Total Users" : "Total Users", value: "500", change: "+10%" },
    { id: 2, label: type === "superadmin" ? "Trial Users" : "Total Projects", value: "500", change: "+10%" },
    { id: 3, label: type === "superadmin" ? "Total Organizations" : "Active", value: "450", change: "+15%" },
    { id: 4, label: type === "superadmin" ? "Total Projects" : "New", value: "30", change: "0%" },
  ]);

  const handleStatUpdate = (id: number, newData: any) => {
    setStats(stats.map(stat => 
      stat.id === id ? { ...stat, ...newData } : stat
    ));
  };

  const selectedIndex = timeFilters.findIndex(filter => filter.id === selectedTime);

  return (
    <div >
      {/* Time Filters */}
      <div className="mb-6">
        <div className="inline-flex bg-[#1A1A1A] rounded-lg relative">
          {/* Sliding background */}
          <div
            className="absolute h-full top-0 bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] rounded-lg transition-all duration-300 ease-out"
            style={{
              width: `${100 / timeFilters.length}%`,
              left: `${(selectedIndex * 100) / timeFilters.length}%`,
            }}
          />
          
          {/* Filter buttons */}
          <div className="relative flex">
            {timeFilters.map((filter, index) => (
              <TimeFilter
                key={filter.id}
                label={filter.label}
                isActive={selectedTime === filter.id}
                onClick={() => setSelectedTime(filter.id)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Stat Widgets */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 custom-grid-cols-lg">
        {stats.map(stat => (
          <StatWidget
            key={stat.id}
            label={stat.label}
            value={stat.value}
            change={stat.change}
            onUpdate={(newData: any) => handleStatUpdate(stat.id, newData)}
          />
        ))}
      </div>
    </div>
  );
} 